import { ReactNode, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRequestData } from '../helpers/helpers';

const BLOCKING_STATUSES = new Set(['SUBMITTED', 'PENDING_PAYMENT', 'SUCCESS']);

interface RequestStatusGateProps {
  children: ReactNode;
}

function getRouteIds(pathname: string) {
  const pathSegments = pathname.split('/');
  return {
    companyId: pathSegments[1],
    requestId: pathSegments[2],
  };
}

export default function RequestStatusGate({ children }: RequestStatusGateProps) {
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const guardRoute = async () => {
      const { companyId, requestId } = getRouteIds(location.pathname);

      if (!companyId || !requestId) {
        setChecking(false);
        return;
      }

      try {
        const data = await getRequestData(companyId, requestId);
        const status = data?.status;

        if (BLOCKING_STATUSES.has(status)) {
          navigate(`/${companyId}/${requestId}/status`, { replace: true });
          return;
        }
      } catch (error) {
        console.error('Error while checking request status:', error);
      }

      setChecking(false);
    };

    guardRoute();
  }, [location.pathname, navigate]);

  if (checking) {
    return null;
  }

  return <>{children}</>;
}
